import { clsx } from 'clsx';
import * as styles from './styles.css';
import { CustomSlider } from '../Slider';
import { SliderItem } from '../SliderItem';
import { REVIEWS_SLIDER_SETTINGS } from 'shared/constants/slider';
import { IconActionArrowLeft24, IconActionArrowRight24 } from '@cian/ui-kit-design-tokens/icons';
import Slider from 'react-slick';
import { TListItemProps } from 'shared/types/list';
import { Responsive, TDeviceType } from '@cian/ui-kit';
import { ListItemBanners } from './components/ListItemBanners';

interface IListItemProps extends TListItemProps {
  onGoNext: VoidFunction;
  onGoPrev: VoidFunction;
  onCurrentSlideIndex: (value: number) => void;
  sliderRef: React.RefObject<Slider>;

  currentSlideIndex: number;
  slidesToShow: number;
  device: TDeviceType;
}

export const ListItem: React.FC<IListItemProps> = ({
  item,
  dealType,
  caCategory,
  currentSlideIndex,
  sliderRef,
  slidesToShow,
  device,
  onCurrentSlideIndex,
  onGoNext,
  onGoPrev,
}) => {
  const { step, title, slider, banner } = item;

  return (
    <div className={clsx(styles['container'], styles[step % 2 !== 0 ? 'even' : 'odd'], styles[device])}>
      <div className={styles['wrapper']}>
        <div className={styles['header']}>
          <Responsive desktop>
            <div className={clsx(styles['step'], styles[dealType])}>{step}</div>
          </Responsive>
          <Responsive tablet phone>
            <div className={clsx(styles['step-text'], styles[dealType])}>{step} шаг</div>
          </Responsive>
          <div className={styles['title']}>{title}</div>
          <Responsive desktop>
            {slider.length > 3 && (
              <div className={styles['arrows']}>
                <div
                  data-name="ArrowPrev"
                  className={clsx(styles['arrow'], currentSlideIndex === 0 && 'slick-disabled')}
                >
                  <IconActionArrowLeft24 onClick={onGoPrev} />
                </div>
                <div
                  data-name="ArrowNext"
                  className={clsx(
                    styles['arrow'],
                    currentSlideIndex === slider.length - slidesToShow && 'slick-disabled',
                  )}
                  onClick={onGoNext}
                >
                  <IconActionArrowRight24 />
                </div>
              </div>
            )}
          </Responsive>
        </div>

        <CustomSlider
          ref={sliderRef}
          {...REVIEWS_SLIDER_SETTINGS}
          afterChange={value => onCurrentSlideIndex(value)}
          slidesToShow={slidesToShow}
        >
          {slider.map((slideItem, key) => (
            <SliderItem key={key} caCategory={caCategory} {...slideItem} />
          ))}
        </CustomSlider>

        {banner && <ListItemBanners {...banner} />}
      </div>
    </div>
  );
};
